<div class="relative h-full">
    <div class="absolute inset-0 columns-2 max-md:hidden">
        <div>&nbsp;</div>
        <div class="auth-hero-container">
            <div class="auth-hero-background">
                <div class="flex size-full flex-col justify-center gap-[16px] px-[100px] text-white">
                    <div class="text-[50px] font-black leading-[50px] tracking-tighter">PS AxP</div>
                    <h4 class="text-justify text-[16px] font-semibold">
                        Turn your sales process into a state of the art, revenue-generating machine. Manage Your
                        Pipeline with Total Visibility
                    </h4>
                </div>
            </div>
        </div>
    </div>
    <div class="container flex h-full items-center gap-[48px] max-md:flex-col">
        <div class="flex-1">
            <router-outlet></router-outlet>
        </div>
        <div class="flex-1">&nbsp;</div>
    </div>
</div>
